module.exports = __webpack_public_path__ + "assets/img/8.ae9769e5.png";